// English translations
const en = {
  // Navigation
  nav: {
    home: "Home",
    applyForVisa: "Apply for Visa",
    trackApplication: "Track Application",
  },
  
  // Home page
  home: {
    heroTitle: "Your Gateway to UAE",
    heroSubtitle: "Fast, reliable, and hassle-free visa processing services",
    getStarted: "Get Started",
    trackApplication: "Track Application",
    whyChooseUs: "Why Choose Us",
    feature1Title: "Fast Processing",
    feature1Desc: "Get your visa processed quickly with our efficient system",
    feature2Title: "Secure & Reliable",
    feature2Desc: "Your documents are handled with utmost security",
    feature3Title: "24/7 Support",
    feature3Desc: "Our team is always here to help you",
    feature4Title: "Affordable Rates",
    feature4Desc: "Competitive pricing for all visa types",
  },
  
  // Visa Application
  apply: {
    title: "Visa Application",
    subtitle: "Complete the form below to apply for your UAE visa",
    step1: "Contact Info",
    step2: "Personal Details",
    step3: "Documents",
    step4: "Family Members",
    step5: "Review & Pay",
    
    // Step 1
    nationality: "Nationality",
    selectNationality: "Select your nationality",
    visaDuration: "Visa Duration",
    selectDuration: "Select visa duration",
    days30: "30 Days Visa",
    days60: "60 Days Visa",
    visaFee: "Visa Fee",
    perPerson: "per person",
    email: "Email Address",
    emailPlaceholder: "Enter your email",
    phone: "Phone Number",
    phonePlaceholder: "Enter your phone number",
    
    // Step 2
    firstName: "First Name",
    lastName: "Last Name",
    fatherName: "Father's Name",
    passportNumber: "Passport Number",
    placeOfBirth: "Place of Birth",
    
    // Step 3
    uploadDocuments: "Upload Documents",
    passportPhoto: "Passport Photo",
    personalPhoto: "Personal Photo",
    idCardFront: "ID Card Front",
    idCardBack: "ID Card Back",
    uploadFile: "Upload file",
    
    // Step 4
    familyMembers: "Family Members",
    addFamilyMember: "Add Family Member",
    removeMember: "Remove",
    familyMemberDetails: "Family Member Details",
    
    // Step 5
    reviewApplication: "Review Your Application",
    applicantInfo: "Applicant Information",
    totalApplicants: "Total Applicants",
    totalFee: "Total Fee",
    submitApplication: "Submit Application",
    processing: "Processing...",
    
    // Navigation
    next: "Next",
    previous: "Previous",
    submit: "Submit",
  },
  
  // Track Application
  track: {
    title: "Track Your Application",
    subtitle: "Enter your email to view all your visa applications",
    emailPlaceholder: "Enter your email address",
    search: "Search",
    searching: "Searching...",
    noApplications: "No applications found for this email",
    applicationId: "Application ID",
    submittedOn: "Submitted on",
    applicantName: "Applicant Name",
    passportNumber: "Passport Number",
    visaType: "Visa Type",
    nationality: "Nationality",
    paymentStatus: "Payment Status",
    totalFee: "Total Fee",
    paid: "Paid",
    pending: "Pending",
    adminNotes: "Admin Notes",
    downloadVisa: "Download Visa",
    familyMemberVisas: "Family Members Visas",
  },
  
  // Payment
  payment: {
    title: "Payment",
    subtitle: "Complete your payment to process your visa application",
    summary: "Payment Summary",
    reviewOrder: "Review your order before proceeding to payment",
    applicantName: "Applicant Name",
    nationality: "Nationality",
    totalApplicants: "Total Applicants",
    applicationId: "Application ID",
    service: "Service",
    visaProcessing: "Visa Processing",
    feePerPerson: "Visa Fee per Person",
    totalAmount: "Total Amount",
    payNow: "Pay Now",
    processing: "Processing...",
    securePayment: "Secure Payment",
    securePaymentDesc: "Your payment is processed securely through Ziina. You can pay using your credit/debit card or other supported payment methods.",
    needHelp: "Need help? Contact us at",
  },
  
  // Payment Success
  paymentSuccess: {
    title: "Payment Successful!",
    subtitle: "Your visa application has been submitted successfully",
    applicationId: "Application ID",
    whatNext: "What's Next?",
    step1: "Our team will review your application",
    step2: "You'll receive email updates on your application status",
    step3: "Once approved, you can download your visa from the track page",
    trackApplication: "Track Application",
    backHome: "Back to Home",
  },
  
  // Footer
  footer: {
    description: "Your trusted partner for visa services in UAE. We make your travel dreams come true with hassle-free visa processing.",
    quickLinks: "Quick Links",
    contactUs: "Contact Us",
    allRights: "All rights reserved",
  },
  
  // Support
  support: {
    needHelp: "Need Help?",
    description: "Our support team is here to assist you with your visa application.",
    emailSupport: "Email Support",
    callUs: "Call Us",
    available: "Available 9 AM - 6 PM (GST)",
  },
  
  // Common
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    days: "Days",
  },
};

export default en;
